// src/features/auth/signup/components/StoreSelect.tsx

import React from 'react';

import type {
  StoreListItem,
} from '../types/signup.types';

interface StoreSelectProps {
  storeId: number;

  storeList: StoreListItem[];

  isLoading: boolean;

  errorMessage: string;

  disabled?: boolean;

  inputClassName: string;

  labelClassName: string;

  onChange: (
    storeId: number,
  ) => void;
}

export default function StoreSelect({
  storeId,
  storeList,
  isLoading,
  errorMessage,

  disabled = false,

  inputClassName,
  labelClassName,

  onChange,
}: StoreSelectProps) {
  return (
    <div>
      <label
        htmlFor="storeId"
        className={labelClassName}
      >
        소속 매장

        <span className="ml-1 text-red-500">
          *
        </span>
      </label>

      <select
        id="storeId"
        value={
          storeId > 0
            ? String(storeId)
            : ''
        }
        disabled={
          disabled ||
          isLoading ||
          storeList.length === 0
        }
        onChange={(event) => {
          const value =
            event.target.value;

          onChange(
            value
              ? Number(value)
              : 0,
          );
        }}
        className={`${inputClassName} appearance-none`}
      >
        <option
          value=""
          disabled
        >
          {isLoading
            ? '매장 목록을 불러오는 중입니다'
            : '소속 매장을 선택해주세요'}
        </option>

        {storeList.map(
          (store) => (
            <option
              key={store.storeId}
              value={store.storeId}
            >
              {store.storeName}
            </option>
          ),
        )}
      </select>

      {errorMessage && (
        <p className="mt-1.5 text-xs text-red-600">
          {errorMessage}
        </p>
      )}
    </div>
  );
}